import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CLAIMDOCUMENTS_FEATURE_KEY,
  ClaimDocumentsState,
  claimDocumentEntityAdapter
} from './claim-documents.reducer';
import { claimLinesQuery } from '@ecosure-suite/back-office/claims/claim-lines/data-access-claim-lines';
import { claimRequestsQuery } from '@ecosure-suite/back-office/claims/claim-requests/data-access-claim-requests';
import { claimDocumentTypesQuery } from '@ecosure-suite/back-office/claims/claim-document-types/data-access-claim-document-types';

// Lookup the 'ClaimDocuments' feature state managed by NgRx
const getClaimDocumentsState = createFeatureSelector<ClaimDocumentsState>(
  CLAIMDOCUMENTS_FEATURE_KEY
);

export const {
  selectIds: getClaimDocumentIds,
  selectEntities: getClaimDocumentEntities,
  selectAll: getAllClaimDocuments,
  selectTotal: getTotalClaimDocuments
} = claimDocumentEntityAdapter.getSelectors(getClaimDocumentsState);

const getLoaded = createSelector(
  getClaimDocumentsState,
  (state: ClaimDocumentsState) => state.loaded
);

const getLoading = createSelector(
  getClaimDocumentsState,
  (state: ClaimDocumentsState) => state.loading
);

const getError = createSelector(
  getClaimDocumentsState,
  (state: ClaimDocumentsState) => state.error
);

const getSelectedId = createSelector(
  getClaimDocumentsState,
  (state: ClaimDocumentsState) => state.selectedId
);

const getSelectedClaimDocument = createSelector(
  getClaimDocumentEntities,
  getSelectedId,
  (claimDocuments, id) => {
    const result = claimDocuments[id];
    return result ? Object.assign({}, result) : undefined;
  }
);

const getClaimOwners = createSelector(
  getAllClaimDocuments,
  claimRequestsQuery.getSelectedClaimRequest,
  claimLinesQuery.getSelectedClaimLines,
  claimDocumentTypesQuery.getSelectedClaimDocumentTypes,
  (documents, claimRequest, claimLines, claimDocumentTypes) =>
    claimLines.reduce((documentTypes, claimLine) => {
      return claimDocumentTypes
        .filter(
          type =>
            type.claimLineTypeId === claimLine.claimTypeId ||
            type.claimLineTypeId === null
        )
        .map(type => ({
          ownerType: type.claimLineTypeId ? `CLAIM_LINE` : `CLAIM_REQUEST`,
          ownerValue: type.claimLineTypeId ? claimLine.id : claimRequest.id,
          claimTypeId: type.claimLineTypeId,
          claimDocumentType: Object.assign({}, type, {
            documents: documents.filter(
              document =>
                document.type === type.typeId &&
                document.owner.value ===
                  (type.claimLineTypeId ? claimLine.id : claimRequest.id)
            )
          })
        }));
    }, [])
);

export const claimDocumentsQuery = {
  getLoaded,
  getLoading,
  getError,
  getAllClaimDocuments,
  getSelectedClaimDocument,
  getClaimOwners
};
